import React, { lazy } from 'react'
import ComponentLoader from './component-loader'
import WebAppRedirect from 'layouts/public/web-app-redirect'
import Download from 'layouts/authentication/register/personal/download'
import InvoiceView from 'layouts/public/invoice-view'

const GeneratePass = ComponentLoader(
  lazy(() => import('../layouts/public/genreate_pass')),
)

// const Demos = ComponentLoader(
//   lazy(() => import('../layouts/authentication/register/personal/demo'))
// )
// const Download = ComponentLoader(
//   lazy(() => import('../layouts/authentication/register/personal/download'))
// )

const PublicRoutes = [
  {
    path: 'claim-card/*',
    element: <WebAppRedirect />,
  },
  {
    path: 'generate-pass',
    element: <GeneratePass />,
  },
  {
    path: 'create-password',
    element: <WebAppRedirect />,
  },
  {
    path: 'demo',
    // element: <Demos />,
  },
  {
    path: 'pass/:passCode',
    element: <Download />,
  },
  {
    path: 'invoice/:shareToken',
    element: <InvoiceView />,
  },
]

export default PublicRoutes
